import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface TotalStopsIconProps {
  color?: string;
  style?: React.CSSProperties;
}

export default function TotalStopsIcon({
  color = RoutalPalette.secondary20,
  style = {},
  ...props
}: TotalStopsIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 12 12" style={{ height: `14px`, width: `14px`, ...style }}>
      <g>
        <path
          d="M6 0.762482C4.83767 0.762482 3.72295 1.15665 2.90106 1.85829C2.07917 2.55992 1.61743 3.51154 1.61743 4.50379C1.61743 7.99818 5.56174 11.0174 5.71075 11.1446C5.79073 11.2046 5.89354 11.2377 6 11.2377C6.10646 11.2377 6.20927 11.2046 6.28925 11.1446C6.46017 11.0174 10.3826 7.99818 10.3826 4.50379C10.3826 4.01248 10.2692 3.52597 10.049 3.07206C9.82872 2.61814 9.5059 2.2057 9.09894 1.85829C8.69198 1.51087 8.20885 1.23529 7.67714 1.04727C7.14542 0.859254 6.57553 0.762482 6 0.762482ZM6 10.3477C5.12349 9.59946 2.49395 7.14142 2.49395 4.50379C2.49395 3.70999 2.86333 2.94869 3.52084 2.38739C4.17836 1.82608 5.07014 1.51074 6 1.51074C6.92986 1.51074 7.82164 1.82608 8.47916 2.38739C9.13667 2.94869 9.50605 3.70999 9.50605 4.50379C9.50605 7.12271 6.87651 9.58824 6 10.3477Z"
          fill={color}
        />
        <path
          d="M2.83042 7.48716C3.22283 8.20718 4.834 9.98665 5.9404 10.7761C6.84798 10.2027 8.55242 8.2281 9.06854 7.54888C9.71368 6.69985 9.88039 5.12139 9.88039 3.7315C9.88039 2.63219 7.48833 1.07901 5.9404 1.07901C4.36923 1.07901 2.23429 2.59104 2.03514 3.7315C1.88281 4.60386 2.528 6.93228 2.83042 7.48716Z"
          fill={color}
        />
        <path
          d="M4.09461 4.7693C5.08917 4.7693 5.89569 5.56557 5.89569 6.5475C5.952 6.60806 6.04854 6.60806 6.10385 6.5475C6.10385 5.56557 6.91036 4.7693 7.90492 4.7693C7.96626 4.7137 7.96626 4.61839 7.90492 4.56378C6.91036 4.56378 6.10385 3.76751 6.10385 2.78558C6.04753 2.72502 5.951 2.72502 5.89569 2.78558C5.89569 3.76751 5.08917 4.56378 4.09461 4.56378C4.03327 4.61938 4.03327 4.71469 4.09461 4.7693Z"
          fill={RoutalPalette.neutral00}
        />
      </g>
    </SvgIcon>
  );
}
